import { render, staticRenderFns } from "./WarehouseResortList.vue?vue&type=template&id=1392f539&"
import script from "./WarehouseResortList.vue?vue&type=script&lang=ts&"
export * from "./WarehouseResortList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports